import { URL } from "../constants/constant";
import axios from "axios";

const searchItems = async (city, pincode, providerId, query, accessToken) => {
	const url = `${URL.mb_wapi}Labs/Search/${city}/${pincode}/${query}/10/false?ProviderId=${providerId}`;

	return await axios.get(url, { headers: { accesstoken: accessToken } });
};

const fetchCorporatePackages = async (accesstoken, city, pincode, platform = "phlebo", servingProviderId = 0) => {
	const url = `${URL.mb_wapi}Labs/v1/FetchCorporatePackages`;
	const headers = {
		accesstoken,
		city,
		pincode,
		platform,
	};

	return (
		await axios.post(url, { fetchRetailPackages: false, servingProviderId }, { headers: headers })
	)?.data;
};

const fetchSponsoredBenefs = async (accesstoken) => {
	const url = `${URL.mb_wapi}labs/v1/sponsored-beneficiary`;
	const headers = {
		accesstoken,
	};

	return (await axios.get(url, { headers: headers }))?.data;
};

export default { searchItems, fetchCorporatePackages, fetchSponsoredBenefs };
